























































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import storeRefAsesmen, {
  Category
} from "@/store/modules/new/ReferensiAsesmen";
import {
  bandNyeri,
  judulBandNyeri,
  warnaBandNyeri,
  kodeMetodeNyeri
} from "@/utils/nyeriIntervensi";

interface NyeriKomponen {
  ref_group_id: number;
  ref_group_title: string;
  ref_id: string | null;
  ref_title: string | null;
  skor: number | null;
}

const METODE_KOMPONEN = ["flacc", "nips", "bps"];
const METODE_BASE = ["nrs", ...METODE_KOMPONEN];

const METODE_LABEL: Record<string, string> = {
  nrs: "NRS",
  flacc: "FLACC",
  nips: "NIPS",
  bps: "BPS"
};

const METODE_KETERANGAN: Record<string, string> = {
  nrs: "Pasien sadar dan mampu melaporkan nyeri secara verbal.",
  flacc: "Pasien tidak kooperatif / tersedasi (mis. anak di PICU).",
  nips: "Neonatus 0–28 hari (NICU).",
  bps: "Pasien terintubasi / tersedasi dalam."
};

const KATALOG_KOSONG: Category[] = [];
const OPSI_KOSONG: Category["val"] = [];

@Component
export default class Monitoring24JamIcuNyeriInput extends Vue {
  @Prop({ default: null }) readonly metode!: string | null;
  @Prop({ default: null }) readonly skor!: number | null;
  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean;

  komponen: NyeriKomponen[] = [];
  selectProps = { openOnHover: true, offsetY: true };

  get kode() {
    return kodeMetodeNyeri(this.metode);
  }

  get band() {
    return this.kode !== null && this.skor !== null
      ? bandNyeri(this.kode, this.skor)
      : null;
  }

  get interpretasi() {
    return judulBandNyeri(this.band);
  }

  get warna() {
    return warnaBandNyeri(this.band);
  }

  get metodeItems(): Array<{ text: string; value: string }> {
    const cur = String(this.metode || "");
    const list =
      cur && METODE_BASE.indexOf(cur) === -1
        ? [...METODE_BASE, cur]
        : METODE_BASE;
    return list.map(v => ({
      value: v,
      text: METODE_LABEL[v] || v.toUpperCase()
    }));
  }

  get metodeText(): string {
    const k = String(this.metode || "");
    return METODE_LABEL[k] || k.toUpperCase();
  }

  get metodeKeterangan(): string {
    if (!this.metode) return "";
    return METODE_KETERANGAN[String(this.metode)] || "";
  }

  get pakaiKomponen(): boolean {
    return METODE_KOMPONEN.indexOf(String(this.metode)) !== -1;
  }

  get katalogAktif(): Category[] {
    switch (String(this.metode)) {
      case "flacc":
        return storeRefAsesmen.nyeriFLACC;
      case "nips":
        return storeRefAsesmen.nyeriNIPS;
      case "bps":
        return storeRefAsesmen.nyeriBPS;
      default:
        return KATALOG_KOSONG;
    }
  }

  get skorSlider(): number {
    return typeof this.skor === "number" ? this.skor : 0;
  }

  get komponenLengkap(): boolean {
    return (
      this.komponen.length > 0 && this.komponen.every(i => i.skor != null)
    );
  }

  get totalKomponen(): number | null {
    if (!this.komponenLengkap) return null;
    return this.komponen.reduce((sum, i) => sum + (i.skor || 0), 0);
  }

  opsiKomponen(refGroupId: number) {
    const cat = this.katalogAktif.find(
      c => Number(c.id) === Number(refGroupId)
    );
    return cat ? cat.val : OPSI_KOSONG;
  }

  buildKomponen(): NyeriKomponen[] {
    return this.katalogAktif.map(cat => ({
      ref_group_id: cat.id,
      ref_group_title: cat.title,
      ref_id: null,
      ref_title: null,
      skor: null
    }));
  }

  onMetodeChange(m: string) {
    this.$emit("update:metode", m || null);
    this.komponen = METODE_KOMPONEN.indexOf(String(m)) !== -1
      ? this.buildKomponen()
      : [];
    this.$emit("update:skor", m === "nrs" ? 0 : null);
  }

  onSliderInput(v: number) {
    this.$emit("update:skor", v);
  }

  setKomponen(idx: number, refId: string | null) {
    const row = this.komponen[idx];
    if (!row) return;
    const opsi = this.opsiKomponen(row.ref_group_id).find(
      o => String(o.id) === String(refId)
    );
    row.ref_id = opsi ? opsi.id : null;
    row.ref_title = opsi ? opsi.title : null;
    row.skor = opsi ? Number(opsi.scoring) : null;
    this.$emit("update:skor", this.totalKomponen);
  }

  @Watch("katalogAktif")
  onKatalogTiba() {
    if (this.pakaiKomponen && !this.komponen.length && this.katalogAktif.length) {
      this.komponen = this.buildKomponen();
    }
  }

  @Watch("metode")
  onMetodeHydrated(val: string | null, oldVal: string | null) {
    if (val === oldVal) return;
    this.komponen =
      METODE_KOMPONEN.indexOf(String(val)) !== -1 && this.katalogAktif.length
        ? this.buildKomponen()
        : [];
  }

  loadKatalogNyeri() {
    if (!storeRefAsesmen.nyeriFLACC.length) storeRefAsesmen.getNyeriFLACC();
    if (!storeRefAsesmen.nyeriNIPS.length) storeRefAsesmen.getNyeriNIPS();
    if (!storeRefAsesmen.nyeriBPS.length) storeRefAsesmen.getNyeriBPS();
  }

  created() {
    this.loadKatalogNyeri();
    if (this.pakaiKomponen && this.katalogAktif.length) {
      this.komponen = this.buildKomponen();
    }
  }
}
